"use client";
import React,{useState, useContext} from 'react'
import { ProductProvider } from '../components/Productcontext'
// import Producthomecontent from '../components/Producthomecontent'
import ProductContext from '../components/Productcontext';
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';

import LightningAccessoriesSubMenu from '../components/LightningAccessoriesSubMenu';

import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import clpban1 from '../images/lightningcategory/clp_page_banner.jpg';
import clpban1_360 from '../images/lightningcategory/clp_page_banner_360.jpg';
import clpban1_tab from '../images/lightningcategory/clp_page_banner_tab.jpg';
import clpban1_2x from  '../images/lightningcategory/clp_page_banner@2x.jpg';
import Equipotentialbusbardetails from '../components/Equipotentialbusbardetails';
import CLPPagecontent from '../components/CLPPagecontent';


const BusbarPage = () => {
  const [selectedItem, setSelectedItem] = useState(null);
       // const [ipageValue, setIpageValue] = useState(ipage);
        // const { selectedProduct,selectedLightacc } = useContext(null);
        const handleItemClick = (item) => {
          setSelectedItem(item);
          //setIpageValue(item);
          //console.log("set new ipaf vale "+item);
          //onImageClick(item); // Call the function passed as prop with the clicked item
        };

        const t1=``
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Conventional lightning conductor (Franklin rod) with down conductor" bannertext="" ban1x={clpban1} ban2x={clpban1_2x} ban360={clpban1_360} bantab={clpban1_tab}/>
                <ProductsubMenu/>
            
                
                <CLPPagecontent/>
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default BusbarPage
 
